import { createReducer } from '@reduxjs/toolkit';
import { SELECT_PRIVATE_MONEY } from '../actions/private-moneys';
import { components } from '../schema/docs/api/admin';

type PrivateMoney = components['schemas']['PrivateMoney'];

type PrivateMoneyState = {
  selected?: PrivateMoney;
};

const initState: PrivateMoneyState = {
  selected: {},
};

const privateMoneyReducer = createReducer(initState, (builder) =>
  builder.addCase(SELECT_PRIVATE_MONEY, (state, action) => {
    return { ...state, selected: action.payload };
  })
);

export default privateMoneyReducer;
